import { createAction } from 'redux-actions';

export const resetMaster = createAction('AGREEMENT_RESET_MASTER');
